<template>
    <div class="data_block">
        <div class="data_title flex" :class="className" @click="toggleContent">
            <div class="title">
                {{ transparency.name }}
            </div>
            <div class="date">
                {{ transparency.meetingDate | formatDate }}
            </div>
        </div>
        <div class="data_content jsToggleContent">
            <div class="content">
                <content-builder :value="displayableContent" />
            </div>
            <div v-if="isAnyFile" class="button_wrapper text_left">
                <button
                    class="btn btn_green"
                    type="button"
                    @click="downloadFiles"
                >
                    לקובץ המלא
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import getMediaUrl from '@/helpers/getMediaUrl';
import ContentBuilder from '@/components/elements/ContentBuilder';

export default {
    components: {
        ContentBuilder
    },

    props: {
        transparency: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            className:
                'transparency-button' +
                Math.random()
                    .toString(36)
                    .substring(2, 15)
                    .match(/[a-zA-Z]+/g)
                    .join('')
        };
    },

    computed: {
        isAnyFile() {
            return this.transparency.content.some(item => item.key !== 'text');
        },

        displayableContent() {
            return this.transparency.content.filter(
                item => item.key === 'text'
            );
        }
    },

    methods: {
        ...mapActions({
            initJQuery: 'scripts/initJQuery'
        }),

        toggleContent() {
            this.initJQuery();

            const $ = window.jQuery;

            $(`.${this.className}`)
                .toggleClass('active')
                .next('.jsToggleContent')
                .slideToggle(200);
        },

        async downloadFiles() {
            const files = this.transparency.content.filter(
                item => item.key !== 'text'
            );

            for (const { value: file } of files) {
                const url = getMediaUrl(file);
                const name = `${this.transparency.name}.${file.extension}`;

                this.$downloadFile(url, name);
            }
        }
    }
};
</script>
